import { ShuOption } from '../shu';

/**
 * 台別データ一覧専用：選択されている種別と選択可能な種別一覧の内容に応じて適切な種別を返す
 *
 * 共通の `utils/shu.ts` の `checkCurrentShu` と異なり、台別データ一覧では shuList の先頭に
 * 「種別全体（type === 'none' / defaultShu）」が含まれる前提のため、初期表示（currentShu 未選択時）
 * や一覧に含まれない場合のフォールバックでは「種別全体」をスキップして実種別の先頭を返す。
 *
 * shuList が空・実種別が一切無いケースの安全側として、戻り値は `ShuOption | undefined`。
 * 呼び出し側で undefined を必ず分岐すること。
 *
 * @param shuList 選択可能な種別一覧（先頭が種別全体である想定）
 * @param currentShu 現在選択されている種別
 */
export const checkCurrentShuForUnitDataList = (
  shuList: ShuOption[],
  currentShu?: ShuOption
): ShuOption | undefined => {
  const fallback = shuList.find((shu) => shu.type !== 'none') ?? shuList.at(0);

  if (currentShu === undefined) {
    return fallback;
  }

  const isInList = shuList.some(
    (shu) => shu.code === currentShu.code && shu.type === currentShu.type
  );
  return isInList ? currentShu : fallback;
};
